import { Component, Input } from '@angular/core';

@Component({
  selector: 'fs-banner-message',
  templateUrl: './banners-message.component.html',
  styleUrls: ['./banners-message.component.scss'],
})
export class BannersComponent {
  // Message will receive a hardcoded string from an HTML template. //
  @Input()
  public message!: string;

  // State value will determine the color of the banner. //
  @Input()
  public state!: string;

  // Action will take the appropriate params to a function. //
  @Input()
  public action: (() => any[]) | null = null;

  // actionText will receive a hardcoded string that'll create a button for users to click.  //
  @Input()
  public actionText!: string;

  constructor() {}

  public handleAction(event: Event): void {
    event.preventDefault();
    if (this.action) {
      this.action();
    }
  }
}
